import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { LocationModel } from '@kanzi-apes/kanzi-models';
import { Observable } from 'rxjs';
import { MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import * as fromLocations from '../../reducers';
import * as Locations from '../../actions';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { map } from 'rxjs/operators';
import { BreadcrumbService } from '@kanzi-apes/kanzi-ui';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-location-detail',
    templateUrl: './location-detail.component.html',
    styleUrls: ['./location-detail.component.scss'],
    standalone: false
})
export class LocationDetailComponent implements OnInit {
  Location$: Observable<LocationModel | null> = this.store.pipe(
    select(fromLocations.getLocation)
  );
  
  constructor(
    private store: Store<fromLocations.State>,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    this.breadcrumbService.setItems([
      {
        label: 'Detalle de locación',
        icon: 'fa-eye',
      },
    ]);
    
    this.route.paramMap
      .pipe(map((params: ParamMap) => Number(params.get('id'))))
      .subscribe((id) => this.store.dispatch(new Locations.LoadLocation(id)));
  }
}
